import styled from "styled-components";
import Screens from "screens";

const textEllipsis = `
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

export default styled.div`
  .jobAd {
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 1px solid #ececec;
    ${({ isGrid }) => isGrid && "height: 9rem;"}

    .companyLogo {
      min-width: 45px;
      width: 45px;
      figure {
        display: flex;
        align-items: center;
      }
    }
    .featured {
      border: 1px solid;
    }
    .info {
      display: flex;
      flex-direction: column;
      margin-left: 25px;
      ${({ isGrid }) =>
        !isGrid &&
        `@media ${Screens.desktop}, ${Screens.largeScreen} {
          max-width: 55%;
        }`}
      ${textEllipsis}
      .title {
        height: ${({ isGrid }) => (isGrid ? "30px" : "40px")};
        margin-bottom: 0;
        margin-right: 2rem;
        ${textEllipsis}
      }
      .jobTitle {
        ${textEllipsis}
      }
      .subInfo {
        ${textEllipsis}
      }
    }
    .date {
      margin-right: 4vw;
    }
    .rightSection {
      display: flex;
      align-items: center;
      flex-direction: row;
      margin-left: auto;
      .date-salary {
        display: flex;
        flex-direction: column;
        position: absolute;
        right: 27%;
      }
      .labels {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
        .tag {
          width: fit-content;
          &:first-child {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
`;
